import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  amount: {
    color: theme.palette.success.light,
  },
  item: {
    marginBottom: 12,
  },
}));

export default useStyles;
